export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44')
];

export const server_loads = [0];

export const dictionary = {
		"/": [6],
		"/automation": [26],
		"/blog": [27],
		"/blog/[slug]": [28],
		"/(redirects)/changelog": [~12],
		"/(redirects)/classroomio.sh": [~13],
		"/(marketing)/compliance-training": [7],
		"/contact": [29],
		"/(marketing)/customer-education": [8],
		"/(marketing)/customer-education/vs-help-docs": [9],
		"/(redirects)/demo": [~14],
		"/(redirects)/devanddesign": [~15],
		"/(redirects)/discord": [~16],
		"/(marketing)/docs-vs-company-academy": [10],
		"/(redirects)/feedback": [~17],
		"/(redirects)/github": [~18],
		"/institutions": [30],
		"/(redirects)/learn": [~19],
		"/mcp-recipes": [31],
		"/(redirects)/new": [~20],
		"/oss-friends": [32],
		"/(marketing)/partner-training": [11],
		"/(redirects)/ph": [~21],
		"/pricing": [33],
		"/(redirects)/privacy": [~22,[2]],
		"/product": [34],
		"/public-courses": [35],
		"/roadmap": [~36],
		"/(redirects)/signup": [~23],
		"/teach": [37,[4]],
		"/teach/register": [~38,[4]],
		"/tools": [39,[5]],
		"/tools/name-picker": [40,[5]],
		"/tools/pomodoro": [41,[5]],
		"/tools/progress": [42,[5]],
		"/tools/stopwatch": [43,[5]],
		"/tools/tic-tac-toe": [44,[5]],
		"/(redirects)/tos": [~24,[3]],
		"/(redirects)/waec": [~25]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';